<template>
  <div>
    <v-dialog v-model="createDialog" max-width="600">
      <v-card color="card">
        <v-card-title>
          <span class="headline">Create Collection</span>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="newCollection.name"
            label="Name"
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="createDialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="createCollection">
            Create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container v-if="!loading">
      <v-row v-if="!$vuetify.breakpoint.mobile">
        <v-col md="7">
          <v-text-field
            class="rounded-xl"
            v-model="show.search"
            :outlined="!$store.state.site.whitelabel"
            append-icon="mdi-magnify"
            label="Search"
            @click:append="getItems(true, true)"
            v-on:keyup.enter="getItems(true, true)"
          ></v-text-field>
        </v-col>
        <v-col md="3">
          <v-select
            v-model="show.selected"
            :items="show.types"
            :outlined="!$store.state.site.whitelabel"
            item-text="name"
            item-value="internalName"
            label="Filter"
            v-on:change="getItems(true, false)"
          ></v-select>
        </v-col>
        <v-col md="2">
          <div class="pt-3">
            <v-btn class="rounded-xl" block @click="createDialog = true">
              Create</v-btn
            >
          </div>
        </v-col>
      </v-row>
      <div v-else>
        <v-text-field
          class="rounded-xl"
          v-model="show.search"
          :outlined="!$store.state.site.whitelabel"
          append-icon="mdi-magnify"
          label="Search"
          @click:append="getItems(true, true)"
          v-on:keyup.enter="getItems(true, true)"
        ></v-text-field>
        <v-select
          class="mt-n4"
          v-model="show.selected"
          :items="show.types"
          :outlined="!$store.state.site.whitelabel"
          item-text="name"
          item-value="internalName"
          label="Filter"
          v-on:change="getItems(true, false)"
        ></v-select>
        <div class="mb-2 mt-n5">
          <v-btn class="rounded-xl" block @click="createDialog = true">
            Create</v-btn
          >
        </div>
      </div>
      <v-row>
        <v-col
          v-for="item in items.rows"
          :key="'item-' + item.id + '-' + (item.shared ? 'shared' : 'owned')"
          md="4"
        >
          <v-card
            :loading="loading"
            class="rounded-xl d-flex flex-column"
            elevation="8"
            style="cursor: pointer"
            :to="'/collections/' + item.id"
          >
            <v-img
              :src="collectionImage(item)"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,1.0)"
              height="200px"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
              <v-card-title>
                {{ item.name }}<v-spacer></v-spacer>
                <small>{{ item.items }} items</small>
              </v-card-title>
              <v-card-subtitle v-if="!item.shared">
                <v-icon v-if="item.shareLink"> mdi-link-variant </v-icon>
                <template v-if="!item.users.length && item.shareLink">
                  ShareLink
                </template>
                <template v-if="item.users.length">
                  <v-icon> mdi-swap-horizontal </v-icon>
                  Shared with {{ item.users.length }} others.
                </template>
              </v-card-subtitle>
              <v-card-subtitle v-if="item.shared && item.user">
                <v-icon v-if="item.shareLink"> mdi-link-variant </v-icon>
                <v-icon> mdi-swap-horizontal </v-icon>
                Shared with me by {{ item.user.username }}
                <v-chip
                  style="padding: 5px"
                  x-small
                  color="dark"
                  v-if="item.recipient.write"
                  >WRITE</v-chip
                >
                <v-chip
                  style="padding: 5px"
                  x-small
                  color="dark"
                  class="ml-1"
                  v-if="item.recipient.configure"
                  >CONFIGURE</v-chip
                >
              </v-card-subtitle>
            </v-img>
          </v-card>
        </v-col>
      </v-row>
      <small> Total Items: {{ items.rows?.length }} </small>
    </v-container>
    <v-container v-else>
      <v-row>
        <v-col>
          <v-card class="rounded-xl" elevation="7">
            <v-container class="text-center">
              <p class="text-lg-h4">Loading...</p>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AjaxErrorHandler from "@/lib/errorHandler"
import dayjs from "dayjs"
const advancedFormat = require("dayjs/plugin/advancedFormat")
dayjs.extend(advancedFormat)

export default {
  name: "Collections",
  data() {
    return {
      items: {
        items: [],
        pager: []
      },
      show: {
        selected: "all",
        search: "",
        types: [
          {
            name: "All",
            internalName: "all"
          },
          {
            name: "Owned by me",
            internalName: "owned"
          },
          {
            name: "Shared with me",
            internalName: "shared"
          }
        ]
      },
      loading: false,
      page: 1,
      createDialog: false,
      newCollection: {
        name: ""
      }
    }
  },
  methods: {
    collectionImage(item) {
      if (item?.image) {
        return "https://i.troplo.com/i/" + item.image
      } else if (item?.preview?.attachment) {
        return "https://i.troplo.com/i/" + item.preview.attachment.attachment
      } else {
        return "https://i.troplo.com/i/a050d6f271c3.png"
      }
    },
    createCollection() {
      this.axios
        .post("/api/v1/collections", {
          name: this.newCollection.name
        })
        .then((res) => {
          this.$router.push("/collections/" + res.data.id)
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    },
    dayjs(params) {
      return dayjs(params)
    },
    getItems() {
      this.loading = true
      this.axios
        .get(
          "/api/v1/collections?search=" +
            this.show.search +
            "&type=" +
            this.show.selected +
            "&page=" +
            this.page
        )
        .then((res) => {
          this.items = res.data
          this.loading = false
        })
        .catch((e) => {
          AjaxErrorHandler(this.$store)(e)
        })
    }
  },
  mounted() {
    this.getItems()
  }
}
</script>

<style scoped></style>
